import { v4 } from 'uuid';

import { BlueprintContext } from '../blueprint-context/blueprint-context.class';
import { NotificationType } from './enums';
import { RecordData } from '../../helpers-classes';
import { NotificationData, NotificationDataIn } from './types';

type NotificationDataResponse = NotificationData;
export const notificationData = (context: BlueprintContext, dataIn: NotificationDataIn = null): NotificationDataResponse => {
	const rd = new RecordData<NotificationDataIn>(dataIn);

	const record: NotificationDataResponse = {
		id: rd.useNewOrPartial<string>('id', v4()),
		refId: rd.useNewOrDefault<string>('refId', null),
		itemRefId: rd.useNewOrDefault<string>('itemRefId', null),
		validationCode: rd.useNewOrDefault<string>('validationCode', null),
		description: rd.useNewOrDefault<string>('description', null),
		createDate: rd.useNewOrDefault<string>('createDate', Date.now().toString()),
		acceptedDate: rd.useNewOrDefault<string>('acceptedDate', null),
		createdBy: rd.useNewOrDefault<string>('createdBy', context.userEmail),
		acceptedBy: rd.useNewOrDefault<string>('acceptedBy', null),
		type: rd.useNewOrDefault<NotificationType>('type', null)
	};

	return record;
};
